const env = (typeof process !== 'undefined' && process.env) ? process.env : {}
const DEFAULT_SUBSCRIPTION_QR = require('./assets/qr.jpg')
const DEFAULT_MINIPROGRAM_QR = require('./assets/code.png')
const DEFAULT_MINIPROGRAM_TTS_QR = require('./assets/miniprogram-tts-qr.jpg')

function readBool(value, defaultValue) {
    if (value == null || value === '') return defaultValue
    return !/^(0|false|no|off)$/i.test(String(value).trim())
}

function readPositiveInt(value, defaultValue) {
    const n = parseInt(value, 10)
    return Number.isFinite(n) && n > 0 ? n : defaultValue
}

function getDefaultApiBaseUrl() {
    if (typeof window !== 'undefined' && window.location) {
        const hostname = String(window.location.hostname || '').toLowerCase()
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://127.0.0.1:1990'
        }
    }
    return 'https://api.shdbrj.com'
}

/**
 * 后端 API 地址。
 * 可通过前端环境变量 VUE_APP_API_BASE_URL 覆盖。
 */
export const API_BASE_URL = String(env.VUE_APP_API_BASE_URL || getDefaultApiBaseUrl()).trim()

/** 带末尾斜线，便于和路径拼接 */
export const API_BASE_URL_SLASH = API_BASE_URL.replace(/\/$/, '') + '/'

/**
 * 登录成功后的订阅号关注引导配置。
 * 可通过 VUE_APP_SUBSCRIPTION_* 环境变量覆盖。
 */
export const SUBSCRIPTION_FOLLOW_ENABLED = readBool(env.VUE_APP_SUBSCRIPTION_FOLLOW_ENABLED, true)
export const SUBSCRIPTION_FOLLOW_TITLE = String(env.VUE_APP_SUBSCRIPTION_FOLLOW_TITLE || '关注订阅号，及时收到更新').trim()
export const SUBSCRIPTION_FOLLOW_DESC = String(env.VUE_APP_SUBSCRIPTION_FOLLOW_DESC || '登录成功。建议顺手关注订阅号，后续更新和通知会更方便。').trim()
export const SUBSCRIPTION_FOLLOW_ACCOUNT_NAME = String(env.VUE_APP_SUBSCRIPTION_FOLLOW_ACCOUNT_NAME || '微信公众号').trim()
export const SUBSCRIPTION_FOLLOW_HINT = String(env.VUE_APP_SUBSCRIPTION_FOLLOW_HINT || '用手机微信扫码即可，不影响继续使用网站。').trim()
export const SUBSCRIPTION_FOLLOW_QR_IMAGE = String(env.VUE_APP_SUBSCRIPTION_FOLLOW_QR_IMAGE || DEFAULT_SUBSCRIPTION_QR)
export const SUBSCRIPTION_FOLLOW_REMIND_DAYS = readPositiveInt(env.VUE_APP_SUBSCRIPTION_FOLLOW_REMIND_DAYS, 1)

export const MINIPROGRAM_WIDGET_ENABLED = readBool(env.VUE_APP_MINIPROGRAM_WIDGET_ENABLED, true)
export const MINIPROGRAM_WIDGET_TITLE = String(env.VUE_APP_MINIPROGRAM_WIDGET_TITLE || '微信小程序').trim()
export const MINIPROGRAM_WIDGET_QR_IMAGE = String(env.VUE_APP_MINIPROGRAM_WIDGET_QR_IMAGE || DEFAULT_MINIPROGRAM_QR)
export const MINIPROGRAM_TTS_QR_IMAGE = String(env.VUE_APP_MINIPROGRAM_TTS_QR_IMAGE || DEFAULT_MINIPROGRAM_TTS_QR)
export const MINIPROGRAM_CHECKIN_QR_IMAGE = String(env.VUE_APP_MINIPROGRAM_CHECKIN_QR_IMAGE || MINIPROGRAM_WIDGET_QR_IMAGE).trim()
